import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: 'Why ProjectFlow', href: '#why' },
    { label: 'Products', href: '#products' },
    { label: 'PayFlow', href: '/payflow' },
    { label: 'Knowledge Center', href: '/knowledge' },
    { label: 'Benefits', href: '#benefits' },
    { label: 'Industries', href: '#industries' },
    { label: 'About', href: '#about' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-[#1A2733]/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <a href="#" className="flex items-center space-x-3 group">
            <div className="w-10 h-10 bg-[#30D5C8] rounded-lg flex items-center justify-center transition-transform group-hover:scale-110">
              <svg
                className="w-6 h-6 text-[#1A2733]"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="6" cy="12" r="2" fill="currentColor" />
                <path d="M12 6 L12 18" />
                <path d="M9 9 L15 9" />
                <path d="M9 15 L15 15" />
                <path d="M18 12 L22 12" />
                <path d="M20 10 L22 12 L20 14" />
              </svg>
            </div>
            <div>
              <div className="text-[#F5F7F8] font-bold text-lg font-['Montserrat'] tracking-tight">
                PROJECTFLOW™
              </div>
              <div className="text-[#CBD3D9] text-xs font-['Montserrat'] tracking-wider">
                AUTOMATIONS
              </div>
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-[#CBD3D9] hover:text-[#30D5C8] font-['Open_Sans'] font-medium text-sm transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-[#F5F7F8] hover:text-[#30D5C8] transition-colors"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#1A2733]/98 backdrop-blur-lg border-t border-[#506273]/30">
          <nav className="px-4 py-6 space-y-4">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="block text-[#CBD3D9] hover:text-[#30D5C8] font-['Open_Sans'] font-medium transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};